import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'

import classnames from 'classnames'

class EventStages extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hideStages: false
    }
  }

  render() {
    const { view, event, stage } = this.props
    const { stages } = event
    const activeStage = stage
    const { hideStages } = this.state

    const activeClassName = classnames({
      'active': activeStage.id === undefined
    })

    return (
      <div className="event-stages">
        <NavLink className="button button-home button--primary" activeClassName={activeClassName} to={view.section ? `/event/${event.id}/${view.section}` : `/event/${event.id}`}>Event</NavLink>

        <ul>
          {
            stages && stages.length > 0
            ? stages.map((stage, index) => {
                return (
                  <li key={index}>
                    <NavLink className="button button--flex button--primary" activeClassName="active" to={view.section ? `/event/${event.id}/stage/${stage.id}/${view.section}` : `/event/${event.id}/stage/${stage.id}`}>{stage.title}</NavLink>
                  </li>
                )
              })
            : null
          }
        </ul>

        {/*
          hideStages
          ? <button className="button-view button--primary" onClick={() => this.setState({hideStages: false})}>View all stages</button>
          : <button className="button-view button--primary" onClick={() => this.setState({hideStages: true})}>Hide stages</button>
        */}

        {
          view.editable
          ? <button className="button-view button--primary" onClick={() => this.props.setModal('EventStageCreateModal', {eventId: event.id})}>Add a stage</button>
          : null
        }
      </div>
    )
  }
}

EventStages.propTypes = {
  view: PropTypes.object,
  event: PropTypes.object,
  stage: PropTypes.object,
  setModal: PropTypes.func
}

EventStages.defaultProps = {
  view: {},
  event: {},
  stage: {},
  setModal: function() {}
}

export default EventStages



// WEBPACK FOOTER //
// ./src/components/event/event-stages.js